var _rect, _path, _path2, _path3, _path4, _path5, _path6;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGmEth(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 38,
    height: 36,
    viewBox: "0 0 38 36",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    y: 0.762695,
    width: 37.1044,
    height: 35,
    rx: 8,
    fill: "#F4F6F8"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.8,
    d: "M18.3096 6.625V15.4313L25.9624 18.7572L18.3096 6.625Z",
    fill: "#454A75"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M18.3102 6.625L10.6562 18.7572L18.3102 15.4313V6.625Z",
    fill: "#454A75"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.8,
    d: "M18.3096 24.4633V30.447L25.9675 20.1426L18.3096 24.4633Z",
    fill: "#454A75"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M18.3102 30.447V24.4623L10.6562 20.1426L18.3102 30.447Z",
    fill: "#454A75"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M18.3096 23.0803L25.9624 18.7586L18.3096 15.4346V23.0803Z",
    fill: "#454A75"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.8,
    d: "M10.6562 18.7586L18.3102 23.0803V15.4346L10.6562 18.7586Z",
    fill: "#454A75"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGmEth);
export default __webpack_public_path__ + "static/media/gmETH.d3d4d7528849fdfe74d416d21bd7d9b3.svg";
export { ForwardRef as ReactComponent };